const types = {
  VALIDATE_ZIP_INSURANCE: '@@PO_insurance/VALIDATE_ZIP_INSURANCE',
  SET_ADDRESS_DATA: '@@PO_insurance/SET_ADDRESS_DATA',
  SET_ERROR: '@@PO_insurance/SET_ERROR',
  GET_INSURANCE_FILTERS: '@@PO_insurance/GET_INSURANCE_FILTERS',
  SET_INSURANCE_FILTERS: '@@PO_insurance/SET_INSURANCE_FILTERS',
  SAVE_INSURANCE_CARD: '@@PO_insurance/SAVE_INSURANCE_CARD',
  SET_INSURANCE_CARDS: '@@PO_insurance/SET_INSURANCE_CARDS',
  GET_LICENSE_KEY_RULES: '@@PO_insurance/GET_LICENSE_KEY_RULES',
  SET_INSURANCE_SKIP_FLAG: '@@PO_insurance/SET_INSURANCE_SKIP_FLAG',
  SET_SHOW_CCOF_FLAG: '@@PO_insurance/SET_SHOW_CCOF_FLAG',
  SET_HIDE_SKIP_BUTTON_CCOF: '@@PO_insurance/SET_HIDE_SKIP_BUTTON_CCOF',
};

export interface FilterDataPayload {
  zipCode: string;
  typeOfCare: string;
  patientType: string;
}

export interface InsuranceCardPayload {
  id: number;
  frontCard: File;
  backCard: File;
  system: string;
}

export interface FiltersDTO {
  concerns: Array<{ name: string }>;
  populations: Array<{ name: string }>;
  interventions: Array<{ name: string }>;
  focusOptions: Array<{ name: string; options: Array<{ label: string; value: string }> }>;
  marketing_referrals: Array<{
    display_marketing_referral: string;
    amd_marketing_referral: string;
  }>;
  gender_identity: string[];
}

export interface LicenseKeyRulesDTO {
  insurance_skip_option_flag: boolean;
  enable_credit_card_on_file: boolean;
  disable_skip_credit_card: boolean;
}

export default types;
